## Shared

header-logo-alt = {-company-name}, Startseite Online-Portal

## Help Seekers

help-seeker-fields =
  { $field ->
    *[x_unknown] [{$field}]
    [password] Passwort
    [current_password] Aktuelles Passwort
    [new_password] Neues Passwort
    [new_password_repeated] Neues Passwort wiederholen
    [email] E-Mail-Adresse
    [name] Benutzername
    [hash] Hash
    [terms] Datenschutzerklärung
    [users] Benutzer:innen
  }

## Login

auth-login-login = Anmelden
auth-login-welcome = Willkommen im Online-Portal der {-company-short-name}

auth-login-intro =
  <p>Als gemeinnützige {-company-short-name} ist es unser Ziel, Menschen dabei zu unterstützen, zu gesundheitlichen und gesundheitsrechtlichen Themen den Überblick zu behalten, Zusammenhänge besser zu verstehen und selbstbestimmte Entscheidungen zu ihrer Gesundheit zu treffen.</p>
  <p>Die Beratung richtet sich allein nach Ihren Interessen und Bedürfnissen und ist unabhängig von Dritten – das heißt, sie wird nicht von Pharmafirmen, Versicherungen, Behörden, Kliniken oder anderen Institutionen beeinflusst.</p>
  <p>Die Nutzung dieses Beratungsportals ist kostenfrei, vertraulich und kann anonym erfolgen. Ihre Daten sind sicher und geschützt.</p>
  <p>Um unsere Angebote auf diesem Beratungsportal zu nutzen, loggen Sie sich bitte ein, falls Sie bereits ein Konto angelegt haben, oder erstellen Sie sich zunächst ein neues Konto.</p>

auth-login-registration-title = Zum ersten Mal hier? So registrieren Sie sich
auth-login-registration-description =
  <p>Auf unserer Platform können Sie uns Ihre Anliegen direkt mitteilen und Ihre Beratung bequem online verfolgen. Die Nutzung ist kostenfrei und vertraulich. Im nächsten Schritt brauchen Sie nur eine E-Mailadresse und einen Benutzernamen anzugeben.</p>
auth-login-registration-button = Registrieren

auth-login-page-title = Zu meinem persönlichen Konto
auth-login-description =
  <p>Wenn Sie sich bereits registriert haben kommen Sie hier zu Ihrem persönlichen Bereich.</p>
auth-login-button = Anmelden
auth-login-success = Sie erhalten in Kürze einen Link per E-Mail. Klicken Sie den Link in der E-Mail an. Mit diesem Link können Sie sich in Ihr Benutzerkonto einloggen. Wenn Sie keine E-Mail erhalten, prüfen Sie bitte auch Ihr Spam-Postfach.
auth-login-back-to-login = Zurück zur Anmeldung

## Header

auth-header-nav-label = Hauptmenü
auth-header-nav-return-to-home = Zurück zur Website der {-company-short-name}

## Footer

auth-footer-nav-main = Hauptmenü der Website der {-company-short-name}
auth-footer-nav-service = Servicemenü der Website der {-company-short-name}
auth-footer-homepage = Startseite
auth-footer-advisory-service = Beratungsangebot
auth-footer-information = Informationen
auth-footer-press = Presse
auth-footer-careers = Karriere
auth-footer-about-us = Über uns
auth-footer-imprint = Impressum
auth-footer-data-privacy = Datenschutz
auth-footer-accessibility = Barrierefreiheit
auth-footer-logo-alt = {-company-name} Logo
auth-footer-copyright = © { DATETIME($date, year: "numeric") } {-company-name}. Alle Rechte vorbehalten.
auth-footer-bitv-img-alt = BIK - BITV-konform (geprüfte Seiten), zum Prüfbericht
auth-footer-bitv-img-title = Zum BITV-Test Prüfbericht

## Account activation

auth-account-activation-page-title = Willkommen im Beratungsportal der {-company-short-name}!
auth-account-activation-page-subtitle = Vergeben Sie ein Passwort für die sichere Anmeldung mit Ihrer E-Mail-Adresse {$email}.
auth-account-activation-expired-link-page-title = Ihr Aktivierungs-Link ist leider nicht mehr gültig
auth-account-activation-expired-link-message = Kein Problem! Sie können einen neuen Link mit Ihrer E-Mail-Adresse anfordern.
auth-account-activation-expired-link-request-new-link = Neuen Aktivierungs-Link anfordern
auth-account-activation-terms-checkbox = Ich bestätige hiermit, dass ich die Allgemeinen Geschäfts-Bedingungen gelesen habe und akzeptiere
auth-account-activation-submit-button = Benutzer:innen-Konto aktivieren
auth-account-activation-terms-link = Allgemeine Geschäfts-Bedingungen

## Set password

auth-set-password-page-title = Neues Passwort
auth-set-password-expired-link-page-title = Ihr Link zum Zurücksetzen des Passworts ist leider nicht mehr gültig
auth-set-password-expired-link-message = Kein Problem! Sie können einen neuen Link mit Ihrer E-Mail-Adresse anfordern.
auth-set-password-expired-link-request-new-link = Neuen Link anfordern
auth-set-password-submit-button = Neues Passwort vergeben
auth-set-password-request-new-link = Neuen Link zum Zurücksetzen des Passworts beantragen

## Forgot password

auth-forgot-password-page-title = Neues Passwort anfordern
auth-forgot-password-message = Wir benötigen eine gültige E-Mail-Adresse von Ihnen, um Sie über neue Maileingänge und freie Chattermine zu benachrichtigen und für den Fall, dass Sie Ihr Passwort zurücksetzen möchten. Ihre Mailadresse wird in keinem Fall veröffentlicht und kann auch nicht von den Berater:innen gesehen werden.
auth-forgot-password-help-message = Falls Sie keinen Zugang mehr zu Ihrer E-Mail-Adresse haben oder Unterstützung benötigen, wenden Sie sich bitte an unseren Support.
auth-forgot-password-submit-button = Passwort zurücksetzen
auth-forgot-password-success = Wenn es sich bei „{$email}“ um ein gültiges Benutzerkonto handelt, wird eine E-Mail mit Anweisungen zum Zurücksetzen Ihres Passworts an die darin hinterlegte E-Mail-Adresse gesendet.
auth-forgot-password-placeholder-email = Hier E-Mail eingeben
auth-forgot-password-error = Ihr Konto konnte leider nicht zurückgesetzt werden. Bitte versuchen Sie es später noch einmal!
auth-forgot-password-back-to-login = Zurück zur Anmeldung

## Registration
auth-register-page-title = Registrierung im Online-Portal der {-company-short-name}
auth-register-intro =
  <h2>Registrierung</h2>
  <p>Sie möchten unsere schriftliche Beratung nutzen? Das freut uns! Uns ist wichtig: Sie können dabei anonym bleiben. Sie müssen keine persönlichen Daten angeben.</p>

  <h2>Voraussetzungen</h2>
  <p>Um die schriftliche Beratung nutzen zu können, müssen Sie sich auf unserer Beratungsplattform anmelden. Hierfür müssen Sie sich mit Ihrer E-Mail-Adresse registrieren und sich einen Benutzernamen geben.</p>

  <h2>Sicherheit und Vertraulichkeit</h2>
  <p>Ihre Daten sind bei uns sicher. Alle Nachrichten in der schriftlichen Beratung sind verschlüsselt. Das heißt: Nur Sie und der/die Ihnen zugewiesene Berater:in können die Nachrichten lesen. Alle Mitarbeitenden der {-company-short-name} sind zur Einhaltung des Datengeheimnisses verpflichtet. Wir geben keine persönlichen Daten an Dritte weiter.</p>

auth-register-email-field-description =
  <p>Wir benötigen Ihre E-Mail-Adresse, damit wir Sie benachrichtigen können, wenn eine Antwort auf Ihre Beratungsanfrage in Ihrem persönlichen Account eingegangen ist. Ihre E-Mail-Adresse wird in keinem Fall veröffentlicht und kann auch nicht von den Berater:innen gesehen werden.</p>

auth-register-name-field-description =
  <p>Wir benötigen einen Benutzernamen, damit wir Sie in der Beratung ansprechen können. Unter diesem Namen werden Sie für Ihre:n Berater:in sichtbar. Ihr Benutzername muss keinen Hinweis auf Ihre Identität enthalten. Sollte Ihr gewünschter Benutzername schon vergeben sein, können Sie ihn auch mit einer Zahl kombinieren (z.B. Joker07).</p>

auth-register-usage-terms-label = Ich willige ein, dass die {-company-short-name} meine angegebenen Daten zum Zweck der Bearbeitung meiner Beratungsanfrage sowie zur Einrichtung und Verwaltung meines Benutzerkontos verarbeitet.

auth-register-usage-terms-description =
  <p>Weitere Informationen, insbesondere zu Ihren Rechten (Auskunft, Berichtigung, Löschung, Widerruf usw.) finden Sie in unserer <a href="https://patientenberatung.de/datenschutz/" target="_blank">Datenschutzerklärung auf der Website der {-company-short-name}</a>.</p>
  <p>Sie können Ihre Einwilligung jederzeit mit Wirkung für die Zukunft widerrufen, indem Sie Ihren Account löschen.</p>

auth-register-confirm = Registrierung bestätigen
auth-register-success = Vielen Dank für Ihre Registrierung! Sie erhalten in Kürze eine E-Mail mit einem Aktivierungslink, um Ihr Benutzerkonto zu aktivieren.
auth-register-back-to-login = Zurück zur Anmeldung
